import { initializeApp, getApps, getApp } from 'firebase/app';
// import { getFirestore } from 'firebase/firestore'; // You can add other Firebase services as needed
import { getMessaging, getToken, onMessage } from 'firebase/messaging';

import { ACTION_TYPES as USER_ACTION_TYPES } from "../state-areas/user/constants";
import { editUser, getUser, isTicketOpen } from '../../actions';
import { newFCMNotification } from '../state-areas/notifications/actions';
import { navigateAction } from '../state-areas/navigation/actions';

const fcmMiddleware = store => {
  let firebaseApp;
  let isFCMInitialized = false;
  const { dispatch, getState } = store;

  const firebaseConfig = {
    apiKey: process.env.REACT_APP_FB_API_KEY,
    authDomain: process.env.REACT_APP_FB_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_FB_PROJECT_ID,
    storageBucket: process.env.REACT_APP_FB_STORAGE_BUCKET,
    messagingSenderId: process.env.REACT_APP_FB_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_FB_APP_ID,
    measurementId: process.env.REACT_APP_FB_MEASUREMENT_ID,
  };

  const showNotification = (title, options, data) => {
    const notification = new Notification(title, {
      ...options
    });
    notification.onclick = () => {
      // Here notification onClick actions can be specified;
      switch (data?.type) {
        case 'task': {
          const params = new URLSearchParams(window.location.search);
          params.delete('msgId');
          params.set('selectedTask', data?.chatRoomName);
          
          const newUrl = `${window.location.pathname}?${params.toString()}`;
          dispatch(navigateAction(newUrl));
          dispatch(isTicketOpen(true));
          break;
        }
        default: {
          if (data?.link) {
            dispatch(navigateAction(data.link));
          }
        }
      }
      notification.close();
    };
    return notification;
  };

  const processFCMForegroundMessageEvent = eventData => {
    const fn = '[processFCMForegroundMessageEvent]';
    console.debug(fn, 'Data received', eventData)
    dispatch(newFCMNotification(eventData));
    showNotification(eventData?.data?.title, {
      icon: eventData?.data?.senderThumbnail || eventData?.data?.icon,
      body: eventData.data.body,
      requireInteraction: false,
      tag: eventData?.data?.entityId,
    }, eventData?.data);
  }

  const processFCMBackgroundMessageEvent = event => {
    const fn = '[processFCMBackgroundMessageEvent]';
    if (!event || !event.data) {
      console.warn(fn, 'the event will be skipped as there is no data');
      return;
    }

    const payload = event?.data?.payload;

    const origin = event?.origin || event?.originalEvent?.origin;
    const appOrigin = window.location.protocol + '//' + window.location.host;

    if (origin === appOrigin) {
      switch (event?.data?.type) {
        case 'NEW_FCM_BACKGROUND_EVENT': {
          dispatch(newFCMNotification(payload));
          break;
        }
        default: {}
      }
    }
  };

  const initailizeFCM = async (user) => {
    const fn = '[initailizeFCM]';
    try {
      const permission = await Notification.requestPermission();
      console.log(fn, 'permission', permission);
  
      if (permission !== 'granted' || !user?._id) {
        return
      }

      console.log(fn, 'for user', user?._id);
      // src/js/firebase.js already initializes the [DEFAULT] app at module load (same
      // Firebase project, REACT_APP_FIREBASE_* vars). Calling initializeApp again with a
      // config that differs in ANY field (here: storageBucket domain) throws
      // app/duplicate-app and aborts FCM setup entirely — so reuse the existing app.
      firebaseApp = getApps().length ? getApp() : initializeApp(firebaseConfig);
      // const db = getFirestore(firebaseApp); // Initialize other Firebase services if needed

      console.log(fn, 'setting messaging');
      const messaging = getMessaging(firebaseApp);

      console.log(fn, 'setting listener for foreground messages');
      onMessage(messaging, (data) => processFCMForegroundMessageEvent(data));

      console.log('[initailizeFCM] fetching token');
      const token = await getToken(messaging);

      const subscriptions = user?.subscriptions || {};
      const fbSubscriptions = subscriptions['firebase'] || [];

      // Check BEFORE pushing — the old code pushed the token first, so the guard below
      // always found it and editUser never ran: new browser tokens were never saved to
      // the server, so pushes to fresh devices were never delivered.
      if (!fbSubscriptions.includes(token)) {
        fbSubscriptions.push(token);
        subscriptions['firebase'] = fbSubscriptions;

        console.log('[initailizeFCM] send token to server');
        await dispatch(
          editUser(
            {
              _id: user?._id,
              subscriptions,
            },
            async () => {
              await dispatch(getUser(user?._id));
            }
          )
        );
      }

      // Mark initialized on both paths (known and new token). Previously this flag was
      // only set inside the editUser callback, so for already-registered devices FCM
      // re-initialized on every GET_USER success — stacking duplicate onMessage and
      // service-worker listeners (duplicate foreground notifications).
      isFCMInitialized = true;

      console.log(fn, 'setting listener for background messages');
      navigator.serviceWorker.addEventListener('message', (event) => processFCMBackgroundMessageEvent(event));
    } catch (error) {
      console.error('Error while initializing FCM:', error);
    }
  };

  return next => action => {
    const result = next(action);

    switch (action.type) {
      case USER_ACTION_TYPES.GET_USER_REQUEST_SUCCESS: {
        if (isFCMInitialized) {
          return result;
        }

        initailizeFCM(action?.payload);
        break;
      }
      default: 
        return result;
    }

    return result;
  }
}

export default fcmMiddleware;
